import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { class: "modal-dialog modal-dialog-centered" };
var _hoisted_2 = { class: "modal-content" };
var _hoisted_3 = { class: "modal-title d-flex align-items-center justify-content-between" };
var _hoisted_4 = { class: "modal-body d-flex flex-column align-items-center" };
var _hoisted_5 = { class: "policies_content" };
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PoliciesModal',
    props: {
        locales: Object,
        modalTitle: String,
    },
    setup: function (__props, _a) {
        var __expose = _a.expose;
        var props = __props;
        var visible = ref(false);
        var contentWrap = document.querySelector('.content_wrap');
        var showModal = function () {
            var _a;
            visible.value = true;
            var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = "".concat(scrollbarWidth, "px");
            (_a = document.querySelector('.content_wrap')) === null || _a === void 0 ? void 0 : _a.classList.add('z-index-auto');
        };
        var closeModal = function () {
            var _a;
            visible.value = false;
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            (_a = document.querySelector('.content_wrap')) === null || _a === void 0 ? void 0 : _a.classList.remove('z-index-auto');
        };
        __expose({
            showModal: showModal,
            closeModal: closeModal
        });
        return function (_ctx, _cache) {
            return (visible.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal modal-policies fade show d-block",
                    tabindex: "-1",
                    "aria-modal": "true",
                    role: "dialog",
                    onClick: _withModifiers(closeModal, ["self"])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("p", null, _toDisplayString(__props.modalTitle), 1),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "x_btn",
                                    onClick: closeModal
                                }, _cache[0] || (_cache[0] = [
                                    _createElementVNode("svg", {
                                        width: "28",
                                        height: "28",
                                        viewBox: "0 0 28 28",
                                        fill: "none"
                                    }, [
                                        _createElementVNode("path", {
                                            d: "M21 7L7 21M7 7L21 21",
                                            stroke: "#171717",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        })
                                    ], -1)
                                ]))
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _renderSlot(_ctx.$slots, "default")
                                ])
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
